import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Chip,
  Grid,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";

const StaffDebriefList = ({ nextStep, handleStaffDialogClose, formData, handleSubmit, person }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store

  console.log(formData);

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Staff Debrief</Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item lg={8}>
          <Typography sx={{ fontSize: "18px", fontWeight: "bold", color: "#333", mb: 2 }}>
            Staff Debrief List
          </Typography>

          {/* Table */}
          <TableContainer component={Paper} elevation={3}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#E3F2FD" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#1976D2" }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#1976D2" }}>Status</TableCell>
                </TableRow>
              </TableHead>
              {formData &&
                formData?.map((item) => (
                  <TableBody>
                    <TableRow>
                      <TableCell>{item.selectedStaff}</TableCell>
                      <TableCell sx={{ color: "#333" }}>
                        {item?.staffMemberInfo.length === 6 ? "Completed" : "pending"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ))}
            </Table>
          </TableContainer>
          <br />
          <Button color='primary' onClick={() => nextStep()}>
            <AddIcon /> Add Another Record
          </Button>

          {/* Reusable Dialog for Adding Witness */}
        </Grid>

        {/* Incident Management Details Section */}
        <Grid item lg={4}>
          <Box sx={{ p: 2, ml: 2 }}>
            <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold", mb: 2 }}>
              Incident Management
            </Typography>
            <Typography sx={{ fontSize: "14px", mb: 3 }}>Sample Description 1</Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button variant='outlined' color='primary' onClick={handleStaffDialogClose}>
          Cancel
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            handleSubmit();
          }}
          disabled={!formData?.length > 0}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default StaffDebriefList;
